import { render, staticRenderFns } from "./CollegeList.vue?vue&type=template&id=6f4eb98d&scoped=true"
import script from "./CollegeList.vue?vue&type=script&lang=js"
export * from "./CollegeList.vue?vue&type=script&lang=js"
import style0 from "./CollegeList.vue?vue&type=style&index=0&id=6f4eb98d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4eb98d",
  null
  
)

export default component.exports